exports.getVideoid=(url)=>url.split("=")[1]
